// 功能列表
export const FNLIST = [
  {
    key: 'mode',
    tip: '模式',
    enTip: 'Mode',
    iconClass: 'icon-org-chart-mode'
  },
  {
    key: 'level',
    tip: '层级数',
    enTip: 'Level',
    iconClass: 'icon-org-chart-level'
  },
  {
    key: 'orientation',
    tip: '方向',
    enTip: 'Orientation',
    iconClass: 'icon-org-chart-layout'
  },
  {
    key: 'template',
    tip: '模板',
    enTip: 'Template',
    iconClass: 'icon-org-chart-template'
  }
];

// 模板
export const TEMPLATES = [
  {
    value: 'rony',
    label: 'rony'
  },
  {
    value: 'derek',
    label: 'derek'
  },
  {
    value: 'olivia',
    label: 'olivia'
  },
  {
    value: 'diva',
    label: 'diva'
  },
  {
    value: 'mila',
    label: 'mila'
  },
  {
    value: 'polina',
    label: 'polina'
  },
  {
    value: 'mery',
    label: 'mery'
  },

  {
    value: 'belinda',
    label: 'belinda'
  },
  {
    value: 'ula',
    label: 'ula'
  },
  {
    value: 'ana',
    label: 'ana'
  },
  {
    value: 'luba',
    label: 'luba'
  }
];

// 方向
export const ORIENTATIONS = [
  {
    value: 'top',
    label: 'top'
  },
  {
    value: 'bottom',
    label: 'bottom'
  },
  {
    value: 'right',
    label: 'right'
  },
  {
    value: 'left',
    label: 'left'
  },
  {
    value: 'top_left',
    label: 'top_left'
  },
  {
    value: 'bottom_left',
    label: 'bottom_left'
  },
  {
    value: 'right_top',
    label: 'right_top'
  },
  {
    value: 'left_top',
    label: 'left_top'
  }
];

// 模式
export const MODES = [
  {
    value: 'normal',
    label: '普通模式',
    enLabel: 'normal'
  },
  {
    value: 'grouping',
    label: '分组模式',
    enLabel: 'grouping'
  }
];
